import gql from "graphql-tag";
import yesNoFilters from "state/yesNoFilters";
import createFilter from "state/createFilter";

export const addFilterMutation = gql`
  mutation addFilter($type: String!, $value: String!) {
    addFilter(type: $type, value: $value) @client
  }
`;

const dirtyStateQuery = gql`
  query {
    dirtyState @client {
      filters {
        id
        type
        value
      }
    }
  }
`;

export const addFilter = (_, { type, value }, { cache }) => {
  const { dirtyState } = cache.readQuery({ query: dirtyStateQuery });

  const newFilter = createFilter({
    type,
    value,
  });

  const duplicate = dirtyState.filters.find(
    filter => filter.type === type && filter.value === value
  );

  if (duplicate) {
    return null;
  }

  const newFilters = yesNoFilters.includes(type)
    ? dirtyState.filters
        .filter(filter => filter.type !== type)
        .concat(newFilter)
    : dirtyState.filters.concat(newFilter);

  const data = {
    dirtyState: {
      __typename: "DirtyState",
      filters: newFilters,
    },
    articleMatchesPage: 1,
  };

  cache.writeData({ data });
  return null;
};



// WEBPACK FOOTER //
// ./src/mutations/addFilterMutation.js